module.exports = __webpack_public_path__ + "static/media/A2.ae359398.pdf";